import type { FolderForestTreeType } from 'owa-graph-schema';
import { getListViewTypeString } from 'owa-mail-list-store';
import { getListViewTypeForGroup } from 'owa-group-mail-list-actions';

export default {
    selectPrivateDistributionList: {
        name: 'SelectPrivateDistributionList',
    },
    selectFavoriteCategory: {},
    // This DP measures the loading of Group script
    selectGroup: {
        options: {},
    },
    switchGroup: {
        customData: (
            _groupId: string,
            treeType: FolderForestTreeType
        ): {
            TreeType: FolderForestTreeType;
            ListViewType: string;
        } => ({
            TreeType: treeType,
            ListViewType: getListViewTypeString(getListViewTypeForGroup()),
        }),
    },
    navigateFromMeToWe: {
        customData: (
            _groupId: string,
            treeType: FolderForestTreeType
        ): {
            TreeType: FolderForestTreeType;
            ListViewType: string;
        } => ({
            TreeType: treeType,
            ListViewType: getListViewTypeString(getListViewTypeForGroup()),
        }),
    },
};
